import { getAwardedBid } from '../../../legacy/containers/LoadsPage/utils/getAwardedBid'
import { type BidLoad } from '../../domain/Bid'
import { useActiveBid } from './useActiveBid'

export function useAwardedBid(load?: Partial<BidLoad>) {
  const activeBid = useActiveBid(load)
  return getAwardedBid(activeBid, load)
}
